import React, {useEffect, useRef, useState} from "react";
import styles from "./preferences-release-date.module.css";
import texts from "../../assets/ContextProvider/textsLocalized.json";

const PreferencesReleaseDate = ({selectedPreferences, setSelectedPreferences}) => {
  const inputDates = [
    {placeholderValue: texts.preferences["placeholder-date-from"]},
    {placeholderValue: texts.preferences["placeholder-date-to"]},
  ];
  const [focusedInputIndex, setFocusedInputIndex] = useState(null);
  const [selectedYears, setSelectedYears] = useState(["", ""]);
  const containerRef = useRef(null);


  const handleChangeDate = (e, index) => {
    let value = e.target.value;
    value = value.replace(/\D/g, "");

    if (value.length > 4) {
      value = value.slice(0, 4);
    }

    const updatedYears = [...selectedYears];
    updatedYears[index] = value;
    setSelectedYears(updatedYears);
  };


  const handleBlur = (index) => {
    const currentYear = new Date().getUTCFullYear();
    let value = selectedYears[index];

    if (value === "") {
      const updatedYears = [...selectedYears];
      updatedYears[index] = "";
      setSelectedYears(updatedYears);
      setSelectedPreferences({...selectedPreferences, releaseDate: updatedYears});
      return;
    }

    let numericValue = parseInt(value);

    if (!isNaN(numericValue)) {
      if (numericValue < 1980) numericValue = 1980;
      if (numericValue > currentYear) numericValue = currentYear;

      const updatedYears = [...selectedYears];
      updatedYears[index] = numericValue.toString();
      setSelectedYears(updatedYears);
      setSelectedPreferences({...selectedPreferences, releaseDate: updatedYears});
    }

    setFocusedInputIndex(null);
  };


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setFocusedInputIndex(null);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside);
    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, []);


  return (
    <>
      <div className={styles["preferences-dates-title"]}>
        {texts.preferences["release-date"]}
      </div>
      <div ref={containerRef}
           className={styles["preferences-dates-container"]}>
        {inputDates.map((item, index) => {
          const isFocused = focusedInputIndex === index;

          return (
            <div
              className={
                `${styles["preferences-dates-inner-container"]}
                ${isFocused ? `${styles["preferences-dates-selected"]} ${styles["active"]}` : ""}
              `}
              key={index}>
              <input className={styles["preferences-dates-input"]}
                     type="text"
                     placeholder={item.placeholderValue}
                     value={selectedYears[index]}
                     onChange={(e) => handleChangeDate(e, index)}
                     onFocus={() => setFocusedInputIndex(index)}
                     onBlur={() => handleBlur(index)}
                     inputMode="numeric"
                     pattern="[0-9]*"
                     maxLength={4}/>
            </div>);
        })}
      </div>
    </>
  );
};

export default PreferencesReleaseDate;
